export default "__VITE_ASSET__CnHkl69v__"